import { styled } from 'styled-components';
import { Card } from 'antd';
import { computeRemSize } from '@ydistri/theme';

export const SummarySection = styled(Card)<{ $minWidth: string }>`
  min-width: ${props => props.$minWidth};
  .ant-card-body {
    padding-top: ${() => computeRemSize(8)};
  }

  .ant-card-head {
    min-height: ${() => computeRemSize(48)};
  }
`;
